import ReactGA from 'react-ga4'

let hasInitialized = false

export const initAnalytics = () => {
  if (hasInitialized) return

  const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID
  if (gaMeasurementId) {
    hasInitialized = true
    ReactGA.initialize(gaMeasurementId)
  }
}

export const trackPageView = ({ path, title, location }) => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title,
    location,
  })
}

export const trackEvent = ({ event, ...payload }) => {
  ReactGA.event(event, payload)
}

export const trackCtaClick = (payload) => {
  trackEvent({
    event: 'cta_click',
    ...payload,
  })
}
